import morphLayout from "Areas/Documents/graph/utils/morphLayout";
import generateNodeId from "../generateNodeId";
import initializeShowNamesNodeStyles from "../styling/initializeShowNamesNodeStyles";
import calculateDefaultNodeLayout from "../updates/calculateDefaultNodeLayout";
import createNode from "../updates/createNode";
export default (graphComponentRef, layoutAlgorithmRef, renderingManager, setInProgress) => (documentObject) => {
    if (!graphComponentRef.current || !renderingManager)
        return;
    const tag = {
        ...documentObject,
        Id: generateNodeId(graphComponentRef),
        Color: undefined,
        IconId: "General"
    };
    const node = createNode(graphComponentRef, tag, calculateDefaultNodeLayout(graphComponentRef.current));
    if (!node)
        return;
    graphComponentRef.current.selection.clear();
    graphComponentRef.current.selection.setSelected(node, true);
    setInProgress && setInProgress(true);
    initializeShowNamesNodeStyles([tag])
        .then(() => {
        if (!graphComponentRef.current || !graphComponentRef.current.div.isConnected)
            return;
        morphLayout(graphComponentRef, layoutAlgorithmRef, new Set([node]), new Set(), undefined, () => {
            graphComponentRef.current &&
                graphComponentRef.current.div.isConnected &&
                node.layout &&
                graphComponentRef.current.zoomToAnimated(node.layout.center, 1);
            setInProgress && setInProgress(false);
        }, undefined, false, "0s");
    })
        .catch(() => {
        setInProgress && setInProgress(false);
    });
};
